var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "admin-footer", attrs: { id: "main-footer" } },
    [
      _vm._m(0),
      _vm._v(
        "\n    © " +
          _vm._s(_vm.system_year) +
          " Velocity Vehicle Group. All Rights Reserved.\n"
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "page-loader-wrapper loading-container",
        staticStyle: { display: "none" }
      },
      [
        _c("div", { staticClass: "loading" }, [
          _c("img", { attrs: { src: "/static/images/loading.gif" } })
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2da50d10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da50d10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = null
// module chunks = 